import $ from 'jquery';

export default () => {
  const caseListViewsBlockSelector = '#views-exposed-form-article-list-quick-block-case-list';
  const typePlaceholder = Drupal.t('Type');
  const concernsPlaceholder = Drupal.t('Concerns');

  Drupal.behaviors.cases_filter_select = {
    attach: function(context, settings) {
      const $form = $(caseListViewsBlockSelector).first();

      $form.find('select[name="type"]').once('select2-type').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        placeholder: typePlaceholder,
      });
      $form.find('select[name="concerns"]').once('select2-concerns').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
        placeholder: concernsPlaceholder,
      });
      $form.find('select[name="is_disassociated"]').once('select2-is_disassociated').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
      });
    }
  };
}